"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject;

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = __importStar(require("react"));

var styled_1 = __importDefault(require("@emotion/styled"));

var AccordionTab_1 = __importDefault(require("./AccordionTab"));

var frontend_common_1 = require("@ryerson/frontend.common");

var AccordionElem = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\twidth: 100%;\n\tbackground-color: inherit;\n\t@media print {\n\t\tbackground-color: transparent;\n\t}\n"])));

var Accordion = function Accordion(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? "primary" : _ref$type,
      children = _ref.children,
      _ref$multiple = _ref.multiple,
      multiple = _ref$multiple === void 0 ? false : _ref$multiple,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "line" : _ref$variant,
      defaultOpen = _ref.defaultOpen,
      tabClicked = _ref.tabClicked;
  var isMountedRef = (0, react_1.useRef)();
  var tabRefs = (0, react_1.useRef)([]);
  var expandedTab = (0, react_1.useRef)(useDeepLinkTab() || -1);
  var indexedTabNames = [];
  var defaultOpenIndex = -1; // Component Mounts

  (0, react_1.useLayoutEffect)(function () {
    isMountedRef.current = true;
    var childCount = react_1.default.Children.count(children);

    if (typeof defaultOpen === "number") {
      defaultOpenIndex = defaultOpen;
    } else if (typeof defaultOpen === "string") {
      defaultOpenIndex = indexedTabNames.indexOf(defaultOpen); // Note: `indexOf` will return -1 when string is not found.
    } // If using deep linking "expandedTab.current" will have a value  which should be used


    defaultOpenIndex = expandedTab.current >= 0 ? expandedTab.current : defaultOpenIndex; // Open the default tab if available

    if (isMountedRef && childCount && defaultOpenIndex >= 0) {
      defaultOpenIndex <= childCount && toggleTab(defaultOpenIndex);
    }

    return function () {
      return isMountedRef.current = false;
    };
    /*eslint-disable-next-line */
  }, []); // Deep linking support function

  function findHashInTabChildren(hashString) {
    var indexFound;
    react_1.default.Children.forEach(children, function (tab, index) {
      if ((0, frontend_common_1.isReactElement)(tab) && tab.type === AccordionTab_1.default) {
        var urlHash = tab.props.urlHash;

        if (!!urlHash) {
          !((urlHash === null || urlHash === void 0 ? void 0 : urlHash.indexOf("#")) >= 0) && (urlHash = "#" + urlHash);
          urlHash === hashString && (indexFound = index);
        }
      }
    });
    return indexFound;
  } // Deep linking support function


  function getHashPropByChildIndex(tabIndex) {
    var foundHash = undefined;
    react_1.default.Children.forEach(children, function (child, index) {
      if ((0, frontend_common_1.isReactElement)(child) && child.type === AccordionTab_1.default) {
        var urlHash = child.props.urlHash;

        if (!!urlHash && tabIndex === index) {
          foundHash = urlHash;
        }
      }
    });
    return foundHash;
  } // Deep linking support function
  // check if url hash exists AND is contained in children


  function useDeepLinkTab() {
    var currWindowHash;
    var tabIndexFromUrlHash;

    if (typeof window !== "undefined") {
      currWindowHash = window.location.hash;
    }

    if (!!currWindowHash) {
      tabIndexFromUrlHash = findHashInTabChildren(currWindowHash);
    }

    return tabIndexFromUrlHash;
  }

  var isSelected = function isSelected(index) {
    var deepLinkTabIndex = useDeepLinkTab();

    if (typeof deepLinkTabIndex !== "undefined") {
      expandedTab.current = deepLinkTabIndex;
    }

    return expandedTab.current === index;
  };

  var getTabRef = function getTabRef(index) {
    return tabRefs.current[index];
  };

  var handleTabClick = function handleTabClick(id, dataIndex) {
    // deep linking  check child by id
    var tabHashProp = getHashPropByChildIndex(id); // set browser url hash

    if (typeof tabHashProp !== "undefined" && typeof window !== "undefined") {
      window && tabHashProp && (window.location.hash = tabHashProp);
    } // either open or close tab contents


    var action = toggleTab(id, dataIndex);
    tabClicked && action && tabClicked(dataIndex || id, action);
  };

  var toggleTab = function toggleTab(id, dataIndex) {
    var _a;

    var action = "",
        isAlreadyOpen = expandedTab.current === id;

    if (multiple) {
      var curTabRef = getTabRef(id).current;

      if (curTabRef && curTabRef.isExpanded()) {
        action = "close";
        curTabRef.close();
      } else {
        action = "open";
        curTabRef.open();
      }

      tabClicked && action && tabClicked(dataIndex || id, action);
      return action;
    } else {
      // A tab is currently open, close selected tab
      if (expandedTab.current >= 0) {
        // close the existing tab and open the currently selected tab
        !multiple && !isAlreadyOpen && (action = "open");
        getTabRef(expandedTab.current).current.close();
        getTabRef(id).current.open();
        expandedTab.current = id;
      } else {
        // no tabs are currently open, open selected tab
        var currentTab = getTabRef(id);

        if (currentTab) {
          (_a = currentTab.current) === null || _a === void 0 ? void 0 : _a.open();
          action = "open";
          expandedTab.current = id;
        }
      }

      return action;
    }
  };

  var renderElements = function renderElements() {
    return react_1.default.Children.map(children, function (child, index) {
      if ((0, frontend_common_1.isReactElement)(child) && child.type === AccordionTab_1.default) {
        var tab = child;
        var tabRef = (0, react_1.createRef)();
        tabRefs.current.splice(index, 1, tabRef);
        tab.props.dataTabId && indexedTabNames.push(tab.props.dataTabId);
        return (0, jsx_runtime_1.jsx)(AccordionTab_1.default, {
          type: type,
          circled: tab.props.circled,
          tabRef: tabRef,
          size: tab.props.size,
          tabIndex: index,
          header: tab.props.header,
          expanded: isSelected(index),
          variant: variant,
          onClick: function onClick(index) {
            return handleTabClick(index, tab.props.dataTabId);
          },
          maxHeight: tab.props.maxHeight,
          multiple: multiple,
          dataTabId: tab.props.dataTabId,
          tabHeaderRef: tab.props.tabHeaderRef,
          numberIcon: tab.props.numberIcon,
          isLastAccordionTab: react_1.default.Children.count(children) === index + 1,
          onOpen: tab.props.onOpen,
          onClose: tab.props.onClose,
          children: tab.props.children
        }, index);
      } else {
        return child;
      }
    });
  };

  return (0, jsx_runtime_1.jsx)(AccordionElem, {
    children: renderElements()
  });
};

exports.default = Accordion;